import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, ElementRef } from "@angular/core";
import { DatasetDatapoint } from "../designer/shared/datasetdatapoint.model";
import { GlobalsService } from "../globals.service";
import { PreviewService } from "../preview/shared/preview.service";
import * as $ from "jquery";
import { saveAs as fileSave } from "file-saver";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../confirm-dialog/confirm-dialog.component";
import { GuardScheduleEditorComponent } from "../guards/guard-schedule-editor/guard-schedule-editor.component";
import { MatDialog } from "@angular/material/dialog";
import { ValidationResult } from "../preview/shared/preview.model";
import { Router } from "@angular/router";
import { invoiceNavigationQueryParams } from "../invoicing/shared/invoice-navigation";

@Injectable({ providedIn: "root" })
export class BindTemplateService {
  //public initRecords: InitRecord[] = [];

  private previewService: PreviewService;
  private elRef: ElementRef<any>;

  constructor(
    private router: Router,
    private http: HttpClient,
    private globalsService: GlobalsService,
    private dialog: MatDialog,
  ) {}

  public setPreviewService(previewService: PreviewService) {
    this.previewService = previewService;
  }

  private bindExternalLogin(nativeElement: HTMLElement) {
    const externalLoginElements =
      nativeElement.querySelectorAll(".external-login");

    externalLoginElements.forEach((element) => {
      if (element.getAttribute("external-login-listener") !== "true") {
        const pwd: HTMLElement = document.getElementById("external-login");

        if (pwd) {
          pwd.addEventListener("keyup", this.keyup.bind(this, pwd));

          element.addEventListener("click", this.externalLogin.bind(this, pwd));
          element.setAttribute("external-login-listener", "true");
          //this.globalsService.log(`--> bind-template.service: added listener to externalLoginElement`);
        }
      }
    });
  }

  private bindJqDt(nativeElement: HTMLElement) {
    const jqdtSelector = ".jq-datatable";
    const jqdtElements = nativeElement.querySelectorAll(jqdtSelector);

    jqdtElements.forEach((element) => {
      if (element.getAttribute("jq-datatable-initted") !== "true") {
        $(element)
          .DataTable({
            retrieve: true,
            stripeClasses: [],
            pagingType: "simple_numbers",
            autoWidth: true,
            responsive: true,
            lengthMenu: [10, 50, 100],
            order: [],
            language: {
              aria: {
                sortAscending: ": Activate to sort column ascending",
                sortDescending: ": Activate to sort column descending",
              },
            },
          })
          .columns.adjust();
      }

      element.setAttribute("jq-datatable-initted", "true");
      this.globalsService.log(
        "--> bind-template.service: jq-datatable element initted",
      );
    });
  }

  private bindScript(nativeElement: HTMLElement) {
    const scriptSelector = `script[type="text/javascript"],script[type="custom-js"]`;
    const scriptElements = nativeElement.querySelectorAll(scriptSelector);

    scriptElements.forEach((element) => {
      if (element.getAttribute("script-listener") != "true") {
        let code = (element as HTMLElement).innerText;
        code = this.globalsService.loadGlobals(code);

        const args = {
          $myJQ: $,
        };
        const result: object = new Function(code).call(args);

        element.setAttribute("script-listener", "true");
      }
    });
  }

  private bindTooltip(nativeElement: HTMLElement) {
    const tooltipSelector = ".jq-tooltip";
    const tooltipElements = nativeElement.querySelectorAll(tooltipSelector);

    tooltipElements.forEach((element) => {
      if (element.getAttribute("tooltip-listener") != "true") {
        $(element).tooltip({
          template:
            '<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
        });
        element.setAttribute("tooltip-listener", "true");
      }
    });
  }

  private bindDatasetDetail(nativeElement: HTMLElement) {
    const addDatasetDetailSelector = ".add-dataset-detail";
    const addDatasetDetailElements = nativeElement.querySelectorAll(
      addDatasetDetailSelector,
    );

    addDatasetDetailElements.forEach((element) => {
      if (element.getAttribute("dataset-detail-listener") != "true") {
        const gbviNode = element.attributes["gbvi"];
        const k1Node = element.attributes["key1"];
        const k2Node = element.attributes["key2"];
        const nNode = element.attributes["note"];
        const rrNode = element.attributes["rerenderid"];
        const ridNode = element.attributes["reportid"];

        if (k1Node && gbviNode) {
          //const hasChangeAttrib = (element.attributes['haschange'] != null) ? element.attributes['haschange'].nodeValue : null;

          const groupByValueIndex = parseInt(gbviNode.nodeValue);
          const key1 = k1Node.nodeValue;
          const key2 = k2Node != null ? k2Node.nodeValue : null;
          const note = nNode != null ? nNode.nodeValue : null;
          const rerenderID = rrNode != null ? rrNode.nodeValue : null;

          //element.addEventListener('change', this.addDatasetDetailAction.bind(this, element, rerenderID, groupByValueIndex, key1, key2, note));
          //element.setAttribute('haschange', 'true');

          element.addEventListener(
            "change",
            this.addDatasetDetailAction.bind(
              this,
              element,
              rerenderID,
              groupByValueIndex,
              key1,
              key2,
              note,
            ),
          );
        }
        element.setAttribute("dataset-detail-listener", "true");
      }
    });
  }

  private bindActionButton(nativeElement: HTMLElement) {
    const buttonSelector = ".action-button";
    const buttonElements = nativeElement.querySelectorAll(buttonSelector);

    buttonElements.forEach((element) => {
      if (element.getAttribute("action-button-listener") != "true") {
        const dtidString = element.attributes["datapointtargetid"]?.nodeValue;
        const fgrString = element.attributes["formgrouprootid"]?.nodeValue;
        const gbviString = element.attributes["groupbyvalueindex"]?.nodeValue;

        if (dtidString || fgrString || gbviString) {
          const formGroupRootID = parseInt(fgrString ?? 0);
          const datapointTargetID = parseInt(dtidString ?? 0);
          const groupByValueIndex = parseInt(gbviString ?? 0);

          const flattened: DatasetDatapoint[] = [];
          this.previewService.flatten(
            this.previewService.datasetDatapoints,
            flattened,
          );

          var displayParentDatapointTargetID: number = null;

          var dtidSet = flattened.filter(
            (dd) => dd.datapointTargetID == dtidString,
          );
          if (dtidSet.length === 1) {
            displayParentDatapointTargetID =
              dtidSet[0].displayParentDatapointTargetID;
          }

          const bidString = element.attributes["buttonid"].nodeValue;

          if (bidString) {
            const buttonID = parseInt(bidString);
            element.addEventListener(
              "click",
              this.buttonAction.bind(
                this,
                buttonID,
                datapointTargetID,
                groupByValueIndex,
                displayParentDatapointTargetID,
              ),
            );
            element.setAttribute("hasclick", "true");
          }
        }

        element.setAttribute("action-button-listener", "true");
      }
    });
  }

  private bindUpdateValue(nativeElement: HTMLElement) {
    const updateValueSelector = ".update-value";
    const updateValueElements =
      nativeElement.querySelectorAll(updateValueSelector);

    updateValueElements.forEach((element) => {
      if (element.getAttribute("update-value-listener") !== "true") {
        const vidString = element.attributes["valueid"].nodeValue;

        if (vidString) {
          const vid = parseInt(vidString);

          const rridNode = element.attributes["rerenderid"];
          var rrid: number = null;
          if (rridNode != null) {
            rrid = parseInt(rridNode.nodeValue);
          }

          const confirmNode = element.attributes["confirm"];
          var confirm: string = null;
          if (confirmNode != null) {
            confirm = confirmNode.nodeValue;
          }

          element.addEventListener(
            "change",
            this.updateValueByID.bind(this, vid, element, confirm, rrid),
          );
          //this.globalsService.log(`--> preview: added listener to update value by ID element: vid=${vid}`);
        }

        element.setAttribute("update-value-listener", "true");
      }
    });
  }

  private bindDownloadImage(nativeElement: HTMLElement) {
    const downloadImageSelector = ".download-image";
    const downloadImageElements = nativeElement.querySelectorAll(
      downloadImageSelector,
    );

    downloadImageElements.forEach((element) => {
      const vidString = element.attributes["valueid"].nodeValue;

      if (vidString) {
        const vid = parseInt(vidString);

        const confirmNode = element.attributes["confirm"];
        var confirm: string = null;
        if (confirmNode != null) {
          confirm = confirmNode.nodeValue;
        }

        if (element.getAttribute("download-image-listener") !== "true") {
          element.addEventListener(
            "click",
            this.downloadValueImage.bind(this, vid, confirm),
          );
          element.setAttribute("download-image-listener", "true");
        }
      }
    });
  }

  private bindPhotoLightbox(nativeElement: HTMLElement) {
    const photoLightboxSelector = ".photo-lightbox";
    const photoLightboxElements = nativeElement.querySelectorAll(
      photoLightboxSelector,
    );

    photoLightboxElements.forEach((element) => {
      if (element.getAttribute("photo-lightbox-listener") !== "true") {
        const vidString = element.attributes["valueid"].nodeValue;

        if (vidString) {
          const vid = parseInt(vidString);

          if (vid) {
            element.addEventListener(
              "click",
              this.showPhotoLightbox.bind(this, vid),
            );
            this.globalsService.log(
              `--> bind-template.service: added listener photo lightbox element: vid=${vid}`,
            );
          }
        }
      }

      element.setAttribute("photo-lightbox-listener", "true");
    });
  }

  private bindDeleteValue(nativeElement: HTMLElement) {
    const deleteValueSelector = ".delete-value";
    const deleteValueElements =
      nativeElement.querySelectorAll(deleteValueSelector);

    deleteValueElements.forEach((element) => {
      if (element.getAttribute("delete-value-listener") !== "true") {
        const vidString = element.attributes["valueid"].nodeValue;
        const confirmNode = element.attributes["confirm"];
        const rridNode = element.attributes["rerenderid"];

        if (vidString) {
          const vid: number = parseInt(vidString);

          var confirm: string = null;
          if (confirmNode != null) {
            confirm = confirmNode.nodeValue;
          }

          var rrid: number = null;
          if (rridNode != null) {
            rrid = parseInt(rridNode.nodeValue);
          }

          element.addEventListener(
            "click",
            this.deleteValueByID.bind(this, vid, confirm, rrid),
          );
          element.setAttribute("delete-value-listener", "true");
          //this.globalsService.log(`--> preview: added listener to delete value by id element: vid=${vid}`);
        }
      }
    });
  }

  private parseOptionalIntegerAttribute(
    rawValue: string | null,
    minValue: number,
  ): number | null {
    if (rawValue == null || rawValue.trim().length === 0) {
      return null;
    }

    const parsedValue = Number(rawValue);
    if (!Number.isInteger(parsedValue) || parsedValue < minValue) {
      return null;
    }

    return parsedValue;
  }

  private resolveSubmitContextFromAttributes(element: Element): {
    datasetID: number | null;
    iteration: number | null;
  } {
    const hasDatasetAttr = element.hasAttribute("datasetid");
    const hasIterationAttr = element.hasAttribute("iteration");

    const datasetID = this.parseOptionalIntegerAttribute(
      element.getAttribute("datasetid"),
      1,
    );
    const iteration = this.parseOptionalIntegerAttribute(
      element.getAttribute("iteration"),
      0,
    );

    if (
      (hasDatasetAttr || hasIterationAttr) &&
      (datasetID == null || iteration == null)
    ) {
      this.globalsService.log(
        `bind-template: invalid submit context attrs (datasetid=${element.getAttribute("datasetid")}; iteration=${element.getAttribute("iteration")}); using active context`,
      );
      return { datasetID: null, iteration: null };
    }

    return { datasetID, iteration };
  }

  private bindSubmit(nativeElement: HTMLElement) {
    const submitTargetSelector = ".submit-target";
    const submitTargetElements =
      nativeElement.querySelectorAll(submitTargetSelector);

    submitTargetElements.forEach((element) => {
      if (element.getAttribute("submit-target-listener") !== "true") {
        const { datasetID, iteration } =
          this.resolveSubmitContextFromAttributes(element);

        const reAttr = element.attributes["rerender"];
        const rerender: boolean = reAttr?.nodeValue === "true";

        const bindto = element.getAttribute("bindto")?.trim() || "click";

        const submitDataElement = element.attributes["submit-data"];
        const submitData = submitDataElement
          ? submitDataElement.nodeValue
          : null;

        element.addEventListener(
          bindto,
          this.submitTarget.bind(
            this,
            datasetID,
            iteration,
            submitData,
            rerender,
          ),
        );
        element.setAttribute("submit-target-listener", "true");
        //this.globalsService.log(`--> bind-template.service: added listener to submit-target rerender=${rerender}`);
      }
    });
  }

  private bindSubmitWithConfirm(nativeElement: HTMLElement) {
    const submitTargetSelector = ".submit-target-confirm";
    const submitTargetElements =
      nativeElement.querySelectorAll(submitTargetSelector);

    submitTargetElements.forEach((element) => {
      if (element.getAttribute("submit-target-confirm-listener") !== "true") {
        const { datasetID, iteration } =
          this.resolveSubmitContextFromAttributes(element);

        const reAttr = element.attributes["rerender"];
        const rerender: boolean = reAttr?.nodeValue === "true";

        const bindto = element.getAttribute("bindto")?.trim() || "click";

        const submitDataElement = element.attributes["submit-data"];
        const submitData = submitDataElement
          ? submitDataElement.nodeValue
          : null;

        const confirmMessage =
          element.attributes["confirm"]?.value?.trim() ||
          "Are you sure you want to submit?";

        element.addEventListener(
          bindto,
          this.submitTargetWithConfirm.bind(
            this,
            datasetID,
            iteration,
            submitData,
            rerender,
            confirmMessage,
          ),
        );
        element.setAttribute("submit-target-confirm-listener", "true");
      }
    });
  }

  private bindUpsertValue(nativeElement: HTMLElement) {
    const upsertValueSelector = ".upsert-value";
    const upsertValueElements =
      nativeElement.querySelectorAll(upsertValueSelector);

    if (upsertValueElements && upsertValueElements.length > 0) {
      upsertValueElements.forEach((element) => {
        if (element.getAttribute("upsert-value-listener") !== "true") {
          const dtidElem = element.attributes["dtid"];
          const didElem = element.attributes["did"];
          const itElem = element.attributes["it"];
          const gbviElem = element.attributes["gbvi"];

          if (dtidElem && didElem && itElem && gbviElem) {
            const did = parseInt(didElem.nodeValue);
            const dtid = parseInt(dtidElem.nodeValue);
            const it = parseInt(itElem.nodeValue);
            const gbvi = parseInt(gbviElem.nodeValue);

            const rridNode = element.attributes["rerenderid"];
            var rrid: number = null;
            if (rridNode != null) {
              rrid = parseInt(rridNode.nodeValue);
            }

            const confirmNode = element.attributes["confirm"];
            var confirm: string = null;
            if (confirmNode != null) {
              confirm = confirmNode.nodeValue;
            }

            element.addEventListener(
              "change",
              this.upsertValue.bind(this, element, dtid, did, it, gbvi, rrid),
            );
            //this.globalsService.log(`--> bind-template.service: added listener to upsert value element: id=${element.id} dtid=${dtid}; did=${did}; it=${it}; bgvi=${gbvi}`);
          }
          element.setAttribute("upsert-value-listener", "true");
        }
      });
    }
  }

  private bindBackButton(nativeElement: HTMLElement) {
    const backButtonElements = nativeElement.querySelectorAll(".back-button");

    backButtonElements.forEach((element) => {
      if (element.getAttribute("back-button-listener") !== "true") {
        element.addEventListener("click", this.backButton.bind(this));
        element.setAttribute("back-button-listener", "true");
        //this.globalsService.log(`--> bind-template.service: added listener to back-button`);
      }
    });
  }

  private bindFileUpload(nativeElement: HTMLElement) {
    const fileUploadSelector = ".file-upload";
    const fileUploadElements =
      nativeElement.querySelectorAll(fileUploadSelector);

    fileUploadElements.forEach((element) => {
      if (element.getAttribute("file-upload-listener") !== "true") {
        const dtidAttr = element.attributes["datapointtargetid"];
        var dtid: number = dtidAttr ? parseInt(dtidAttr.nodeValue) : null;

        const gbviAttr = element.attributes["groupbyvalueindex"];
        var gbvi: number = gbviAttr ? parseInt(gbviAttr.nodeValue) : null;

        const didAttr = element.attributes["datasetid"];
        var did: number = didAttr ? parseInt(didAttr.nodeValue) : null;

        const itAttr = element.attributes["iteration"];
        var it: number = itAttr ? parseInt(itAttr.nodeValue) : null;

        const rridAttr = element.attributes["rerenderid"];
        var rrid: number = rridAttr ? parseInt(rridAttr.nodeValue) : null;

        if (dtid > 0 && gbvi >= 0 && did > 0 && it >= 0) {
          element.addEventListener(
            "change",
            this.uploadFile.bind(this, dtid, gbvi, did, it, rrid),
          );

          this.globalsService.log(
            `--> bind-template.service: added listener to file-upload [dtid=${dtid}; gbvi=${gbvi}]`,
          );
        }

        element.setAttribute("file-upload-listener", "true");
      }
    });
  }

  public bindElements(
    elRef: ElementRef<any>,
    elements: string = null,
    rebind: boolean = false,
  ) {
    //if (this.previewService?.loading == false) {

    this.elRef = elRef;
    let nativeElement = this.elRef.nativeElement;

    //this.globalsService.templateLoadingCount = (nativeElement.querySelectorAll('.template_loading') as NodeList).length;

    if (this.previewService?.templateLoadingCount == 0 || rebind === true) {
      //console.log('bind elements...');
      if (
        rebind === false &&
        nativeElement.getAttribute("elref-bound") === "true"
      ) {
        return;
      }

      if (elements == "external-login") {
        this.bindExternalLogin(nativeElement);
      } else {
        this.bindJqDt(nativeElement);
        this.bindScript(nativeElement);
        this.bindExternalLogin(nativeElement);
        this.bindTooltip(nativeElement);
        this.bindActionButton(nativeElement);
        this.bindDatasetDetail(nativeElement);
        this.bindUpdateValue(nativeElement);
        this.bindDownloadImage(nativeElement);
        this.bindPhotoLightbox(nativeElement);
        this.bindDeleteValue(nativeElement);
        this.bindSubmit(nativeElement);
        this.bindSubmitWithConfirm(nativeElement);
        this.bindUpsertValue(nativeElement);
        this.bindBackButton(nativeElement);
        this.bindFileUpload(nativeElement);
        this.bindNavToGuardRequestForm(nativeElement);
        this.bindNavToInvoicing(nativeElement);
        this.bindOpenScheduleEditor(nativeElement);
      }

      nativeElement.setAttribute("elref-bound", "true");
    }
    //}
  }

  private bindNavToGuardRequestForm(nativeElement: HTMLElement): void {
    const navElements = nativeElement.querySelectorAll(
      ".nav-to-guard-request-form",
    );

    navElements.forEach((element) => {
      if (element.getAttribute("guard-request-form-listener") !== "true") {
        element.addEventListener("click", () => {
          const taskId = element.getAttribute("data-taskid");

          if (!taskId) {
            console.warn(
              "nav-to-guard-request-form missing data-taskid attribute",
            );
            return;
          }

          this.router.navigate([`/guards/guard-request/${taskId}`], {
            queryParams: {
              k: this.globalsService.getOwnerKey(),
              uid: this.globalsService.getCrimeCastUserID(),
            },
          });
        });

        element.setAttribute("guard-request-form-listener", "true");
      }
    });
  }

  private bindNavToInvoicing(nativeElement: HTMLElement): void {
    const navElements = nativeElement.querySelectorAll(".nav-to-invoicing");

    navElements.forEach((element) => {
      if (element.getAttribute("invoicing-listener") !== "true") {
        element.addEventListener("click", () => {
          const siteId =
            element.getAttribute("data-siteid") ??
            element.getAttribute("data-site-id");

          const queryParams = invoiceNavigationQueryParams(
            this.router.url, this.router.parseUrl(this.router.url).queryParams);
          if (siteId) {
            this.router.navigate([`/invoicing/${siteId}`], { queryParams });
            return;
          }

          console.warn("nav-to-invoicing missing data-siteid attribute");
          this.router.navigate(["/invoicing"], { queryParams });
        });

        element.setAttribute("invoicing-listener", "true");
      }
    });
  }

  private bindOpenScheduleEditor(nativeElement: HTMLElement): void {
    const nodes = nativeElement.querySelectorAll(".open-schedule-editor");
    nodes.forEach((el) => {
      const node = el as HTMLElement;
      if (node.getAttribute("schedule-editor-listener") === "true") return;

      node.addEventListener("click", () => {
        const datasetId = Number(
          node.getAttribute("data-datasetid") ??
            node.getAttribute("data-dataset-id"),
        );
        const iteration = Number(node.getAttribute("data-iteration") ?? 0);
        const groupByValueIndex = Number(
          node.getAttribute("data-group-by-value-index") ?? 0,
        );

        const dialogRef = this.dialog.open(GuardScheduleEditorComponent, {
          width: "640px",
          data: { datasetId, iteration, groupByValueIndex },
          autoFocus: false,
          restoreFocus: false,
        });

        const comp = dialogRef.componentInstance;
        comp.datasetId = datasetId;
        comp.iteration = iteration;

        dialogRef.afterClosed().subscribe((payload) => {
          if (payload) {
            console.log("[GuardScheduleEditor] payload", payload);
          }
        });
      });

      node.setAttribute("schedule-editor-listener", "true");
    });
  }

  private uploadFile(
    datapointTargetID: number,
    groupByValueIndex: number,
    datasetID: number,
    iteration: number,
    rerenderID: number,
  ) {
    var progressMode: string = "determinate";
    var uploadProgress: number = 0;

    const inputFile: HTMLInputElement = document.getElementById(
      `inputfile-${datapointTargetID}-${groupByValueIndex}`,
    ) as HTMLInputElement;
    const progressLabel: HTMLInputElement = document.getElementById(
      `progress-${datapointTargetID}-${groupByValueIndex}`,
    ) as HTMLInputElement;
    var message = "";

    //this.setProgress(progressLabel, '', 0);

    const headers = new HttpHeaders();

    const respondentID =
      this.globalsService.getActiveRespondentID() != null
        ? this.globalsService.getActiveRespondentID()
        : 0;

    const path =
      `dataset/${datasetID}/` +
      `${iteration}/` +
      `${datapointTargetID}/${groupByValueIndex}/` +
      `${respondentID}/file`;

    var formData = new FormData();
    if (inputFile.files.length > 0) {
      const file = inputFile.files[0];
      formData.append(file.name, file);
    }

    const req = new HttpRequest("POST", path, formData, {
      headers: headers,
      reportProgress: true,
    });

    this.http.request(req).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          uploadProgress = Math.round((100 * event.loaded) / event.total);

          //this.setProgress(progressLabel, progressMode, uploadProgress);

          if (uploadProgress === 100) {
            progressMode = "buffer";
          }
        } else if (event.type === HttpEventType.ResponseHeader) {
          progressMode = "init";
          uploadProgress = 0;
          //this.setProgress(progressLabel, progressMode, uploadProgress);
        } else if (event.type === HttpEventType.Response) {
          progressMode = "complete";
          uploadProgress = 100;

          // this.setProgress(progressLabel, progressMode, uploadProgress);

          if (rerenderID != null) {
            this.datapointTargetRerender(rerenderID);
          }

          this.globalsService.handleInfo(
            "File successfully uploaded.",
            "File Upload",
          );
        }
      },

      (error) => {
        //this.loading = false;
        this.globalsService.handleError(error, "File Upload");
      },
    );
  }

  public backButton() {
    this.previewService.clearActiveTarget();
  }

  public externalLogin(pwdElement: HTMLInputElement) {
    var pwd = pwdElement.value;

    const sessionKey = this.globalsService.getOwnerKey();
    const path = `login/external?sessionKey=${sessionKey}&password=${pwd}`;
    //console.log(`path=${path}`);
    this.http
      .get<any>(path)
      .toPromise()
      .then((r) => {
        console.log("logged in? " + r);
        if (r === true) {
          this.globalsService.externalLogin();
          this.navigateToSupplierPortal(sessionKey);
        }
      });
  }

  private navigateToSupplierPortal(sessionKey: string) {
    if (!this.globalsService.isSupplierPortalV2Enabled()) {
      return;
    }

    return this.router.navigate(["/supplier-portal"], {
      queryParams: { k: sessionKey },
    });
  }

  private keyup(pwdElement: HTMLInputElement) {
    if ((event as any).key === "Enter") {
      var pwd = pwdElement.value;
      if (pwd.length > 0) {
        this.externalLogin(pwdElement);
      }
    }
  }

  public async getAsDataURL(file) {
    return await this.readFile(file);
  }

  public readFile(file): Promise<any> {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      // Register event listeners
      reader.addEventListener("loadend", (e) => resolve(e.target.result));
      reader.addEventListener("error", reject);

      // Read file
      reader.readAsDataURL(file);
    });
  }

  public async getFileBytes(element: HTMLInputElement): Promise<Int8Array> {
    let image = element.files[0];
    const buffer = await image.arrayBuffer();
    let byteArray = new Int8Array(buffer);
    return byteArray;
  }

  public upsertValue(
    element: HTMLInputElement,
    datapointTargetID: number,
    datasetID: number,
    iteration: number,
    groupByValueIndex: number,
    rerenderID: number = null,
  ) {
    if (element.files && element.files.length > 0) {
      var index = 0;
      var fileCount = element.files.length;
      Array.from(element.files).forEach((file) => {
        this.getAsDataURL(file).then((dataURL) => {
          this.previewService
            .upsertValuePromise(
              datapointTargetID,
              datasetID,
              iteration,
              groupByValueIndex,
              file.name,
              dataURL,
              false,
            )
            .then((_) => {
              if (++index === fileCount) {
                this.datapointTargetRerender(rerenderID);
                this.globalsService.showSave("Saved", 1);
                this.previewService.startRefreshProgressMapTimer(
                  datasetID,
                  iteration,
                  this.globalsService.getActiveRespondentID(),
                );
              }
            });
        });
      });
    } else {
      var groupByValueIndexArr: number[] = [];
      groupByValueIndexArr.push(groupByValueIndex);

      this.previewService.updateValue(
        datapointTargetID,
        datasetID,
        iteration,
        groupByValueIndexArr,
        element.value,
      );
      if (rerenderID != null) {
        this.datapointTargetRerender(rerenderID);
      }
    }
  }

  public submitTarget(
    datasetID: number | null = null,
    iteration: number | null = null,
    submitData: string | null = null,
    rerender: boolean = false,
  ) {
    const normalizedDatasetID =
      Number.isInteger(datasetID) && datasetID > 0 ? datasetID : null;
    const normalizedIteration =
      Number.isInteger(iteration) && iteration >= 0 ? iteration : null;

    this.globalsService.log(`bind-template.submitTarget`);
    this.clearValidationMessages();

    this.previewService.loading = true;
    this.previewService
      .submit(normalizedDatasetID, normalizedIteration, submitData)
      .then((result) => {
        this.previewService.loading = false;
        if (result.success === true) {
          this.globalsService.handleSuccess("Submitted");
          this.previewService.clearActiveTarget();
          if (rerender === true) {
            this.router
              .navigateByUrl("/", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/preview"]);
              });
          }
        } else {
          this.showValidationMessages(result.validationResults);
        }
      })
      .catch((err) => {
        this.previewService.loading = false;
        this.globalsService.handleError(err, "Could not submit.");
      });
  }

  private submitTargetWithConfirm(
    datasetID: number | null = null,
    iteration: number | null = null,
    submitData: string | null = null,
    rerender: boolean = false,
    confirmMessage: string = "Are you sure you want to submit?",
  ) {
    const dialogData = new ConfirmDialogModel(null, confirmMessage);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === true) {
        this.submitTarget(datasetID, iteration, submitData, rerender);
      }
    });
  }

  private showValidationMessages(validationResults: ValidationResult[]) {
    // console.log(validationResults);
    const flattened: DatasetDatapoint[] = [];

    this.previewService.flatten(
      this.previewService.datasetDatapoints,
      flattened,
    );

    validationResults.forEach((vr) => {
      const currentDDs = flattened.filter(
        (f) =>
          f.datapointTargetID > 0 &&
          f.datapointTargetID === vr.datapointTargetID &&
          f.groupByValueIndex === vr.groupByValueIndex,
      );

      currentDDs.forEach((cdd) => {
        cdd.invalid = true;
        cdd.failMessage = vr.validationMessage;
      });

      // template elements by ID
      if (vr.selector) {
        var elems = this.elRef.nativeElement.querySelectorAll(vr.selector);
        elems.forEach((elem) => {
          elem.style.borderColor = "red";
        });
      }
    });

    const requiredMessagesOnly =
      validationResults.length > 0 &&
      validationResults.every((vr) => vr.validationMessage === "*");

    if (requiredMessagesOnly) {
      const missingCount = validationResults.length;
      const itemLabel = missingCount === 1 ? "item" : "all items";
      const responseLabel = missingCount === 1 ? "response" : "responses";
      this.globalsService.handleInfo(
        `Please respond to ${itemLabel} marked with an asterisk.`,
        `Missing ${missingCount} required ${responseLabel}.`,
      );
    } else {
      validationResults.forEach((vr) => {
        this.globalsService.handleInfo(vr.validationMessage);
      });
    }
  }

  private clearValidationMessages() {
    const flattened: DatasetDatapoint[] = [];
    this.previewService.flatten(
      this.previewService.datasetDatapoints,
      flattened,
    );

    flattened.forEach((datasetDatapoint) => {
      datasetDatapoint.invalid = false;
      datasetDatapoint.failMessage = null;
    });
  }

  public addDatasetDetailAction(
    element: HTMLInputElement,
    rerenderID: string,
    groupByValueIndex: number,
    key1: string,
    key2: string,
    note: string,
  ) {
    const datasetID = this.globalsService.getActiveDatasetID();
    const respondentID = this.globalsService.getActiveRespondentID();
    const iteration = this.globalsService.getActiveDatasetIteration();
    const valueText = element.value;

    const path =
      `dataset/detail/${datasetID}/${iteration}/${respondentID}?` +
      `groupByValueIndex=${groupByValueIndex}&key1=${key1}&key2=${key2}&note=${note}&valueText=${valueText}`;

    this.http
      .put<any>(path, null)
      .toPromise()
      .then((_) => {
        if (rerenderID != null) {
          var existingDDs = this.previewService.datasetDatapoints;
          var toRerenderDDs = this.previewService.datasetDatapoints.filter(
            (dd) => dd.datapointTargetID == parseInt(rerenderID),
          );
          this.loadPSRerenders(existingDDs, toRerenderDDs, 0);
        }

        this.globalsService.log(
          `Dataset detail successfully updated [datasetID=${datasetID};respondentID=${respondentID};` +
            `iteration=${iteration};groupByValueIndex=${groupByValueIndex};key1=${key1};` +
            `key2=${key2};note=${note};valueText=${valueText};rerenderID=${rerenderID}]`,
        );
      });
  }

  public buttonAction(
    buttonID: number,
    datapointTargetID: number = 0,
    groupByValueIndex: number = 0,
    displayParentDatapointTargetID: number = null,
  ) {
    //if (this.previewService.loading == false && this.globalsService.templateLoadingCount == 0) {
    const datasetID = this.globalsService.getActiveDatasetID();
    const respondentID = this.globalsService.getActiveRespondentID();
    const iteration = this.globalsService.getActiveDatasetIteration();

    this.globalsService.log(
      `bindService: buttonAction [datasetID=${datasetID};respondentID=${respondentID};` +
        `iteration=${iteration};buttonID=${buttonID};` +
        `datapointTargetID=${datapointTargetID};groupByValueIndex=${groupByValueIndex}]`,
    );

    const path =
      `dataset/button?datasetID=${datasetID}&respondentID=${respondentID}&iteration=${iteration}&` +
      `buttonID=${buttonID}&datapointTargetID=${datapointTargetID}&` +
      `groupByValueIndex=${groupByValueIndex}`;

    this.http
      .get<DatasetDatapoint[]>(path)
      .toPromise()
      .then((toRerender) => {
        if (toRerender) {
          this.previewService.loadRerenders(
            this.previewService.datasetDatapoints,
            toRerender,
            null,
            displayParentDatapointTargetID,
          );
        }
      });
    //}
  }

  public getPSDatapointHtml(
    templateKey: string,
    datapointTargetID: number = 0,
    readOnly: boolean = false,
    hidden: boolean = false,
  ): Promise<any> {
    console.log("getPSDatapointHtml...");

    const targetID = this.globalsService.getActiveTargetID();
    const datasetID = this.globalsService.getActiveDatasetID();
    const iteration = this.globalsService.getActiveDatasetIteration();
    const respondentID = this.globalsService.getActiveRespondentID();

    const route =
      `datapoint/htmltemplate?targetID=${targetID}&datasetID=${datasetID}&respondentID=${respondentID}` +
      `&iteration=${iteration}&templateKey=${templateKey}&datapointTargetID=${datapointTargetID}&readOnly=${readOnly}&hidden=${hidden}`;

    return this.http.get<any>(route).toPromise();
  }

  public loadPSRerenders(
    existingDDs: DatasetDatapoint[],
    toRerenderDDs: DatasetDatapoint[],
    groupByValueIndex = 0,
  ) {
    console.log("loadPSrerenders...");

    this.previewService.loadDatasetDatapointHtml(existingDDs);

    existingDDs.forEach((existingDD, index, array) => {
      toRerenderDDs.forEach((toRerender) => {
        if (
          (toRerender.renderAs === "HTML Template" &&
            (this.previewService?.previewTarget?.targetedElementBinding ??
              true) === false) ||
          ((existingDD.datapointTargetID === toRerender.datapointTargetID ||
            existingDD.subDatapointTargetID === toRerender.datapointTargetID) &&
            existingDD.groupByValueIndex === toRerender.groupByValueIndex &&
            (existingDD.valueText !== toRerender.valueText ||
              existingDD.visible !== toRerender.visible ||
              existingDD.enabled !== toRerender.enabled ||
              existingDD.applicable !== toRerender.applicable ||
              JSON.stringify(existingDD.valueOptions) !==
                JSON.stringify(toRerender.valueOptions)))
        ) {
          this.globalsService.log(
            `toRerender [gbvi=${existingDD.groupByValueIndex}]: ` +
              `name=${existingDD.name}; colName=${existingDD.colName} [${existingDD.valueText}] -> ${toRerender.name} [${toRerender.valueText}]`,
          );

          this.loadValues(existingDD, toRerender);

          this.refresh(toRerender.datapointTargetID);

          return true;
        }
      });

      this.loadPSRerenders(
        existingDD.children,
        toRerenderDDs,
        groupByValueIndex,
      );
    });
  }

  private refresh(dtid: number) {
    console.log("refresh: " + dtid);
    this.globalsService.sendEvent("refresh", dtid);
  }

  public loadValues(loadInto: DatasetDatapoint, loadFrom: DatasetDatapoint) {
    if (loadFrom.valueOptions != null) {
      loadInto.valueOptions = loadFrom.valueOptions;
    } else {
      loadInto.valueText = loadFrom.valueText;
    }
    loadInto.valueDate = loadFrom.valueDate;
    loadInto.valueFormat = loadFrom.valueFormat;
    loadInto.valueNumeric = loadFrom.valueNumeric;
    loadInto.valueBit = loadFrom.valueBit;
    loadInto.visible = loadFrom.visible;
    loadInto.enabled = loadFrom.enabled;
    loadInto.applicable = loadFrom.applicable;
  }

  public downloadValueImage(valueID: number, confirmMessage: string) {
    if (confirmMessage != null) {
      const dialogData = new ConfirmDialogModel(null, confirmMessage);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult === true) {
          this.downloadValueImageFile(valueID);
        }
      });
    } else {
      this.downloadValueImageFile(valueID);
    }
  }

  public downloadValueImageFile(valueID) {
    this.previewService.downloadValueImage(valueID).subscribe((res) => {
      var contentType = res.mimeType;
      var fileDownloadName = res.name;

      var byteCharacters = atob(res.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });

      //var bytes = res;
      fileSave(blob, fileDownloadName);
    });
  }

  public showPhotoLightbox(valueID: number) {
    //console.log(`showPhotoLightbox: ${valueID}`);

    this.previewService.getValueImageURL(valueID, 0).then((url) => {
      //console.log(`got url: ${url.substring(0, 250)}...`);
      const body = document.getElementsByTagName("body")[0];

      var divElement = document.getElementById("lightbox-div-generated");
      var imageElement = document.getElementById("lightbox-img-generated");

      var img: HTMLImageElement;
      var div: HTMLDivElement;

      if (imageElement && divElement) {
        div = divElement as HTMLDivElement;
        img = imageElement as HTMLImageElement;

        //console.log('found div and image, updating img src...');
        img.src = url;
        div.removeAttribute("hidden");
      } else {
        //console.log('create image...');
        div = document.createElement("div");
        img = document.createElement("img");
        img.src = url;
        img.id = "lightbox-img-generated";
        img.style.maxWidth = "100%";
        img.style.maxHeight = "100%";
        img.style.padding = "60px";

        img.style.padding = "60px";
        div.id = "lightbox-div-generated";
        div.style.cursor = "pointer";
        div.style.zIndex = "10";
        div.style.background = "rgba(0,0,0,.65)";
        div.style.top = "0px";
        div.style.left = "0px";
        div.style.position = "absolute";
        div.style.width = "100%";
        div.style.height = "100%";
        div.style.textAlign = "center";
        div.addEventListener("click", function () {
          this.setAttribute("hidden", "true");
        });
        div.appendChild(img);
        body.appendChild(div);
      }
    });
  }

  public updateValueByID(
    valueID: number,
    element: HTMLElement,
    confirmMessage: string,
    rerenderID: number = null,
  ) {
    const e = element as HTMLInputElement;
    var valueText = e.value;

    if (confirmMessage != null) {
      const dialogData = new ConfirmDialogModel(null, confirmMessage);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult === true) {
          this.updateValueCore(valueID, valueText, rerenderID);
        } else {
          this.datapointTargetRerender(rerenderID);
        }
      });
    } else {
      this.updateValueCore(valueID, valueText, rerenderID);
    }

    //this.datapointTargetRerender(rerenderID);
  }

  private updateValueCore(
    valueID: number,
    valueText: string,
    rerenderID: number,
  ) {
    const route = `value/${valueID}`;

    var body = JSON.stringify(valueText);
    console.log(`updateValueCore: ${body}}`);

    this.http
      .put<any>(route, body)
      .toPromise()
      .then(
        (_) => {
          //this.datapointTargetRerender(rerenderID);
          this.globalsService.showSave("Saved", 1);
        },
        (error) => {
          this.datapointTargetRerender(rerenderID);
          this.globalsService.handleError(error);
        },
      );
  }

  public deleteValueByID(
    valueID: number,
    confirmMessage: string,
    rerenderID: number = null,
  ) {
    if (confirmMessage != null) {
      const dialogData = new ConfirmDialogModel(null, confirmMessage);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult === true) {
          this.deleteValueCore(valueID, rerenderID);
        }
      });
    } else {
      this.deleteValueCore(valueID, rerenderID);
    }
  }

  private deleteValueCore(valueID: number, rerenderID: number) {
    const route = `value/${valueID}`;

    //console.log(route);
    this.http
      .delete<any>(route)
      .toPromise()
      .then(
        (_) => {
          this.datapointTargetRerender(rerenderID);
          this.globalsService.showSave("Deleted", 1);

          if (this.previewService != null) {
            this.previewService.startRefreshProgressMapTimerExternal();
          }
        },
        (error) => {
          this.datapointTargetRerender(rerenderID);
          this.globalsService.handleError(error);
        },
      );
  }

  private datapointTargetRerender(rerenderID: number) {
    if (rerenderID != null) {
      var existingDDs = this.previewService.datasetDatapoints;
      var flattened: DatasetDatapoint[] = [];
      this.previewService.flatten(
        this.previewService.datasetDatapoints,
        flattened,
      );
      var toLoadDDs = flattened.filter(
        (dd) => dd.datapointTargetID == rerenderID,
      );
      this.previewService.loadRerenders(existingDDs, toLoadDDs);
    }
  }
}
